//====================================================
//  Initialization Counter
//====================================================
function fn_parts_placeholder(){
	if ($('.js-placeholder-trigger').length){
		$('.js-placeholder-trigger').on('click', function () {
            $(this).find('label').addClass('active');
	    });

        $('.js-placeholder-trigger > input, .js-placeholder-trigger > textarea').on('focus', function () {
            $(this).parent('.js-placeholder-trigger').find('label').addClass('active');
        });
	}
}

